import {Avatar, Box, Card, CardContent, Divider, Stack, Typography} from "@mui/material";
import type {TicketManagerStatistic} from "@/global/api/gen/ts/TicketManagerStatistic";
import {formatDuration} from "@/global/helpers/formatters";

interface Props {
    managerStats: TicketManagerStatistic,
}

export function EmployerCard({managerStats}: Props) {
    return (
        <Card
            sx={{
                backgroundColor: '#05304F',
                borderRadius: '20px',
                minWidth: {xs: '100%', sm: '49%', lg: '32%'},
                scrollSnapAlign: 'start',
            }}
        >
            <CardContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                }}
            >
                <Stack
                    gap={1}
                    flexDirection={'row'}
                    alignItems={'center'}
                >
                    <Avatar
                        sx={{
                            width: '55px',
                            height: '55px',
                        }}
                    />
                    <Typography color={'white'}>
                        {`${managerStats.last_name} ${managerStats.first_name}`}
                    </Typography>
                </Stack>
                <Divider color={'#FFFFFF'}/>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: ' repeat(2, minmax(0, 1fr))',
                        gridTemplateRows: ' repeat(2, minmax(0, 1fr))',
                    }}
                >
                    <Stack>
                        <Typography color={'#FFFFFF99'}>
                            Закреплено тикетов:
                        </Typography>
                        <Typography color={'#FFFFFF'}>
                            {managerStats.ticket_count}
                        </Typography>
                    </Stack>
                    <Stack>
                        <Typography color={'#FFFFFF99'}>
                            Среднее время:
                        </Typography>
                        <Typography color={'#FFFFFF'}>
                            {formatDuration(managerStats.avg_close_seconds)}
                        </Typography>
                    </Stack>
                    <Stack>
                        <Typography color={'#FFFFFF99'}>
                            Направлено:
                        </Typography>
                        <Typography color={'#FFFFFF'}>
                            {managerStats.mvd_sended_count}
                        </Typography>
                    </Stack>
                    <Stack>
                        <Typography color={'#FFFFFF99'}>
                            Отклонено:
                        </Typography>
                        <Typography color={'#FFFFFF'}>
                            {managerStats.rejected_count}
                        </Typography>
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    );
}